import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EAddNewbuildingFavoriteActionTypes {
  Success = 'ADD_NEWBUILDING_FAVORITE/SUCCESS',
}

interface IPayload {
  newbuildingId: number;
}

type TAddNewbuildingFavoriteSuccess = ITypedReduxAction<EAddNewbuildingFavoriteActionTypes.Success, IPayload>;

export type TAddNewbuildingFavorite = TAddNewbuildingFavoriteSuccess;

export const addNewbuildingFavoriteSuccess = actionGenerator<EAddNewbuildingFavoriteActionTypes.Success, IPayload>(
  EAddNewbuildingFavoriteActionTypes.Success,
);
